import axios from "axios";

/**
 * SharePoint Configuration
 */
const SHAREPOINT_SITE_URL = "https://ekedp.sharepoint.com/sites/CustomerServiceDesk";
const HR_SITE_URL = "https://ekedp.sharepoint.com/sites/hr";
const LIST_NAME = "BusinesscardQRCodeAdmin";
const STAFF_LIST_NAME = "Staff_database";

// The scope required for SharePoint REST API access
export const SHAREPOINT_SCOPE = ["https://ekedp.sharepoint.com/AllSites.Read"];

/**
 * Check if the user's email exists in the BusinesscardQRCodeAdmin list.
 * 
 * @param email - The email of the logged-in user.
 * @param accessToken - The access token for SharePoint.
 * @returns Promise<boolean> - True if the user is an admin, false otherwise.
 */
export const checkAdminStatus = async (email: string, accessToken: string): Promise<boolean> => {
  if (!email || !accessToken) return false;

  try {
    const url = `${SHAREPOINT_SITE_URL}/_api/web/lists/getbytitle('${LIST_NAME}')/items?$filter=Email eq '${email}'`;
    
    const response = await axios.get(url, {
      headers: {
        "Accept": "application/json;odata=verbose",
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    const results = response.data?.d?.results || [];
    return results.length > 0;
  } catch (error) {
    console.error("Error checking SharePoint admin status:", error);
    return false;
  }
};

/**
 * Fetch staff information from the Staff_database list.
 * 
 * @param email - The email of the logged-in user.
 * @param accessToken - The access token for SharePoint.
 * @returns Promise<any> - The staff data object or null.
 */
export const fetchStaffData = async (email: string, accessToken: string): Promise<any> => {
  if (!email || !accessToken) return null;

  try {
    // Note: We use Title for Full Name or a specific field if known. 
    // Usually, SharePoint lists use Title for the primary name.
    const url = `${HR_SITE_URL}/_api/web/lists/getbytitle('${STAFF_LIST_NAME}')/items?$filter=Official_Mail eq '${email}'`;
    
    const response = await axios.get(url, {
      headers: {
        "Accept": "application/json;odata=verbose",
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    const results = response.data?.d?.results || [];
    if (results.length > 0) {
      console.log("Full Staff Object from SharePoint:", results[0]);
    } else {
      console.warn("No staff data found for email:", email);
    }
    return results.length > 0 ? results[0] : null;
  } catch (error) {
    console.error("Error fetching staff data:", error);
    return null;
  }
};
